<template>
  <div id="__error">
    <Nuxt />
  </div>
</template>

<script>
export default {}
</script>
